import { ref, computed, nextTick } from 'vue';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.to-sorted.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c2a6d5fe"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "chart-title"
};
const _hoisted_2 = {
  class: "filters"
};
const _hoisted_3 = {
  key: 0,
  class: "content"
};
const _hoisted_4 = {
  class: "right"
};
import { DownOutlined } from '@ant-design/icons-vue';
import { getMonitorData } from '@/api/monitor';
import Empty from '@/components/Empty.vue';
import MonitorChart from './MonitorChart.vue';
import { reportEvent } from '@/common';
export default /*#__PURE__*/_defineComponent({
  __name: 'PayErrorServerChart',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  setup(__props, {
    expose
  }) {
    const props = __props;
    const loading = ref(false);
    const chartData = ref([]);
    // 切换指标
    const fields = ref(['失败数', '失败率']);
    const currentField = ref('失败数');
    const handleFieldChange = e => {
      currentField.value = e.key;
      handleData();
    };
    // 图表类型
    const chartType = ref('trend');
    const charTypeName = computed(() => {
      var _chartTypeOptions$val;
      return (_chartTypeOptions$val = chartTypeOptions.value.find(item => item.value === chartType.value)) === null || _chartTypeOptions$val === void 0 ? void 0 : _chartTypeOptions$val.label;
    });
    const chartTypeOptions = ref([{
      label: '趋势图',
      value: 'trend'
    }
    // {
    //   label: '堆积图',
    //   value: 'stack',
    // },
    ]);
    const handleChartTypeChange = e => {
      chartType.value = e.key;
    };
    // 图表
    const monitorChartRef = ref(null);
    const formatterNum = params => {
      var _params$;
      const hasCompare = chartData.value.some(itm => itm.metrics.some(m => !!m.compareMetric));
      let str = `<div>
    <div style="marign-bottom:12px;display:flex;align-items:center">
      <div style="width:160px;margin-right:24px">${hasCompare ? '' : (_params$ = params[0]) === null || _params$ === void 0 ? void 0 : _params$.axisValue}</div>
      <div style="width:75px;margin-right:24px">总数</div>
      <div style="width:75px;margin-right:24px">环比</div>
      <div style="width:75px;">同比</div>
    </div>
    <div style="max-height: 400px;overflow: auto">`;
      params.forEach((item, i) => {
        var _chartData$value$idx$, _chartData$value$idx;
        const idx = chartData.value.findIndex(c => c.groupColName === item.seriesName.split(': ')[1]);
        const data = (_chartData$value$idx$ = (_chartData$value$idx = chartData.value[idx]) === null || _chartData$value$idx === void 0 ? void 0 : _chartData$value$idx.metrics[item.dataIndex]) !== null && _chartData$value$idx$ !== void 0 ? _chartData$value$idx$ : {};
        if (hasCompare && i < params.length / 2) {
          str += `<div>${item.marker}${item.seriesName}</div>`;
        }
        if (!item.seriesName.includes('对比')) {
          var _data$currentMertic;
          const {
            weekOverWeekTotal,
            dayOverDayTotal
          } = (_data$currentMertic = data === null || data === void 0 ? void 0 : data.currentMertic) !== null && _data$currentMertic !== void 0 ? _data$currentMertic : {};
          str += `<div style="marign-bottom:12px;display:flex;align-items:center">
          <div style="width:160px;margin-right:24px;padding-left:${hasCompare ? '16px' : '0'}">${!hasCompare ? item.marker : ''}${!hasCompare ? item.seriesName : item.axisValue}</div>
          <div style="width:75px;margin-right:24px"><span style="font-weight: bold;">${item.value || item.value == 0 ? item.value : '-'}</span></div>
          <div style="width:75px;margin-right:24px"><span style="font-weight: bold;">${dayOverDayTotal}</span></div>
          <div style="width:75px;display:inline-block"><span style="font-weight: bold;">${weekOverWeekTotal}</span></div>
        </div>`;
        }
        if (hasCompare && i < params.length / 2) {
          var _data$compareMetric;
          const {
            weekOverWeekTotal,
            dayOverDayTotal,
            dateTime,
            total
          } = (_data$compareMetric = data === null || data === void 0 ? void 0 : data.compareMetric) !== null && _data$compareMetric !== void 0 ? _data$compareMetric : {};
          str += `<div style="marign-bottom:12px;display:flex;align-items:center">
        <div style="width:160px;margin-right:24px;padding-left:16px">${dateTime}</div>
        <div style="width:75px;margin-right:24px"><span style="font-weight: bold;">${total !== null && total !== void 0 ? total : '-'}</span></div>
        <div style="width:75px;margin-right:24px"><span style="font-weight: bold;">${dayOverDayTotal}</span></div>
        <div style="width:75px;display:inline-block"><span style="font-weight: bold;">${weekOverWeekTotal}</span></div>
      </div>`;
        }
      });
      str += '</div></div>';
      return str;
    };
    const formatterRate = params => {
      const hasCompare = chartData.value.some(itm => itm.metrics.some(m => !!m.compareMetric));
      let str = `<div>
    <div style="marign-bottom:12px;display:flex;align-items:center">
      <div style="width:160px;margin-right:24px"></div>
      <div style="width:75px;margin-right:24px">失败率</div>
    </div>
    <div style="max-height: 400px;overflow: auto">`;
      params.forEach((item, i) => {
        var _chartData$value$idx$2, _chartData$value$idx2;
        const idx = chartData.value.findIndex(c => c.groupColName === item.seriesName.split(': ')[1]);
        const data = (_chartData$value$idx$2 = (_chartData$value$idx2 = chartData.value[idx]) === null || _chartData$value$idx2 === void 0 ? void 0 : _chartData$value$idx2.metrics[item.dataIndex]) !== null && _chartData$value$idx$2 !== void 0 ? _chartData$value$idx$2 : {};
        if (hasCompare && i < params.length / 2) {
          str += `<div>${item.marker}${item.seriesName}</div>`;
        }
        if (!item.seriesName.includes('对比')) {
          var _data$currentMertic$r;
          str += `<div style="marign-bottom:12px;display:flex;    align-items:center">
          <div style="width:160px;margin-right:24px;padding-left:${hasCompare ? '16px' : '0'}">${!hasCompare ? item.marker : ''}${!hasCompare ? item.seriesName : item.axisValue}</div>
          <div style="width:75px;margin-right:24px"><span style="font-weight: bold;">${(_data$currentMertic$r = data.currentMertic.rate) !== null && _data$currentMertic$r !== void 0 ? _data$currentMertic$r : '-'}</span></div>
        </div>`;
        }
        if (hasCompare && i < params.length / 2) {
          var _data$compareMetric2;
          const {
            rate,
            dateTime
          } = (_data$compareMetric2 = data.compareMetric) !== null && _data$compareMetric2 !== void 0 ? _data$compareMetric2 : {};
          str += `<div style="marign-bottom:12px;display:flex;    align-items:center">
          <div style="width:160px;margin-right:24px;padding-left:16px">${dateTime}</div>
          <div style="width:75px;margin-right:24px"><span style="font-weight: bold;">${rate !== null && rate !== void 0 ? rate : '-'}</span></div>
        </div>`;
        }
      });
      str += '</div></div>';
      return str;
    };
    // 处理图表数据
    const handleData = () => {
      let xAxis = [];
      const seriesData = [];
      const legends = [];
      const color = ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'];
      chartData.value.forEach((item, i) => {
        const {
          groupColName,
          metrics
        } = item;
        if (xAxis.length === 0) {
          xAxis.push({
            type: 'category',
            boundaryGap: false,
            data: metrics.map(m => {
              return m.currentMertic.dateTime;
            })
          });
        }
        const legendName = `道具下发${currentField.value}: ${groupColName}`;
        legends.push(legendName);
        seriesData.push({
          name: legendName,
          type: 'line',
          lineStyle: {
            type: 'solid',
            color: color[i]
          },
          itemStyle: {
            color: color[i]
          },
          data: metrics.map(m => {
            if (currentField.value === '失败数') {
              var _m$currentMertic$tota;
              return (_m$currentMertic$tota = m.currentMertic.total) !== null && _m$currentMertic$tota !== void 0 ? _m$currentMertic$tota : '';
            } else {
              var _m$currentMertic$rate;
              if ((_m$currentMertic$rate = m.currentMertic.rate) !== null && _m$currentMertic$rate !== void 0 && _m$currentMertic$rate.includes('%')) {
                return m.currentMertic.rate.split('%')[0];
              }
              if (m.currentMertic.rate === -1 || m.currentMertic.rate === null) {
                return 0;
              } else {
                return m.currentMertic.rate;
              }
            }
          }),
          xAxisIndex: 0,
          symbol: 'circle',
          symbolSize: 5
        });
        if (metrics[0].compareMetric) {
          const seriesName = '对比' + legendName;
          // legends.push(seriesName)
          seriesData.push({
            name: seriesName,
            type: 'line',
            lineStyle: {
              type: 'dashed',
              color: color[i]
            },
            itemStyle: {
              color: color[i]
            },
            data: metrics.map(m => {
              if (currentField.value === '失败数') {
                var _m$compareMetric$tota;
                return (_m$compareMetric$tota = m.compareMetric.total) !== null && _m$compareMetric$tota !== void 0 ? _m$compareMetric$tota : '';
              } else {
                var _m$compareMetric$rate;
                if ((_m$compareMetric$rate = m.compareMetric.rate) !== null && _m$compareMetric$rate !== void 0 && _m$compareMetric$rate.includes('%')) {
                  return m.compareMetric.rate.split('%')[0];
                }
                if (m.compareMetric.rate === -1 || m.compareMetric.rate === null) {
                  return 0;
                } else {
                  return m.compareMetric.rate;
                }
              }
            }),
            xAxisIndex: 1,
            symbol: 'circle',
            symbolSize: 5
          });
          if (xAxis.length === 1) {
            xAxis.push({
              type: 'category',
              boundaryGap: false,
              position: 'bottom',
              offset: 16,
              axisLine: {
                show: false
              },
              data: metrics.map(m => {
                return m.compareMetric.dateTime;
              })
            });
          }
        }
        nextTick(() => {
          var _monitorChartRef$valu;
          const options = {
            tooltip: {
              trigger: 'axis',
              enterable: true,
              formatter: currentField.value === '失败数' ? formatterNum : formatterRate
            },
            legend: {
              data: legends,
              top: '93%',
              icon: 'circle',
              itemWidth: 10
            },
            color,
            grid: {
              left: '3%',
              right: '8%',
              bottom: '10%',
              top: 24,
              containLabel: true
            },
            xAxis,
            yAxis: {
              type: 'value'
            },
            series: seriesData.toSorted((a, b) => a.xAxisIndex - b.xAxisIndex)
          };
          (_monitorChartRef$valu = monitorChartRef.value) === null || _monitorChartRef$valu === void 0 || _monitorChartRef$valu.createChart(options);
        });
      });
    };
    // 获取接口数据
    const getData = params => {
      loading.value = true;
      const startTime = new Date().getTime();
      getMonitorData(params).then(res => {
        if (res.code === '0') {
          reportEvent({
            eventName: '_search',
            properties: {
              ui_name: `监控看板${props.title}搜索`,
              app_name: '',
              return_duration: new Date().getTime() - startTime,
              query_status: 'succeed'
            }
          });
          chartData.value = res.data;
        } else {
          reportEvent({
            eventName: '_search',
            properties: {
              ui_name: `监控看板${props.title}搜索`,
              app_name: '',
              return_duration: new Date().getTime() - startTime,
              query_status: 'failed'
            }
          });
          chartData.value = [];
        }
        handleData();
        loading.value = false;
      }).catch(err => {
        reportEvent({
          eventName: '_search',
          properties: {
            ui_name: `监控看板${props.title}搜索`,
            app_name: '',
            return_duration: new Date().getTime() - startTime,
            query_status: 'failed'
          }
        });
        loading.value = false;
      });
    };
    expose({
      getData
    });
    return (_ctx, _cache) => {
      const _component_a_menu_item = _resolveComponent("a-menu-item");
      const _component_a_menu = _resolveComponent("a-menu");
      const _component_a_dropdown = _resolveComponent("a-dropdown");
      const _component_a_space = _resolveComponent("a-space");
      const _component_a_spin = _resolveComponent("a-spin");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, _toDisplayString(__props.title), 1), _createElementVNode("div", _hoisted_2, [_createVNode(_component_a_space, {
        size: 24
      }, {
        default: _withCtx(() => [_createVNode(_component_a_dropdown, {
          trigger: ['click']
        }, {
          overlay: _withCtx(() => [_createVNode(_component_a_menu, {
            onClick: handleFieldChange
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields.value, field => {
              return _openBlock(), _createBlock(_component_a_menu_item, {
                key: field
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(field), 1)]),
                _: 2
              }, 1024);
            }), 128))]),
            _: 1
          })]),
          default: _withCtx(() => [_createElementVNode("a", {
            class: "ant-dropdown-link",
            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
          }, [_createTextVNode(_toDisplayString(currentField.value) + " ", 1), _createVNode(_unref(DownOutlined))])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_a_dropdown, {
        trigger: ['click']
      }, {
        overlay: _withCtx(() => [_createVNode(_component_a_menu, {
          onClick: handleChartTypeChange
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chartTypeOptions.value, item => {
            return _openBlock(), _createBlock(_component_a_menu_item, {
              key: item.value
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("a", {
          class: "ant-dropdown-link",
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
        }, [_createTextVNode(_toDisplayString(_unref(charTypeName)) + " ", 1), _createVNode(_unref(DownOutlined))])]),
        _: 1
      })]), _createVNode(_component_a_spin, {
        spinning: loading.value
      }, {
        default: _withCtx(() => {
          var _chartData$value;
          return [(_chartData$value = chartData.value) !== null && _chartData$value !== void 0 && _chartData$value.length ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(MonitorChart, {
            ref_key: "monitorChartRef",
            ref: monitorChartRef,
            chartId: __props.title
          }, null, 8, ["chartId"])])])) : (_openBlock(), _createBlock(Empty, {
            key: 1
          }))];
        }),
        _: 1
      }, 8, ["spinning"])]);
    };
  }
});